import { Tabs } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { PROPERTY_TYPES } from '../../common/drmTypes'
import { ForeclosureMonitoringTab } from '../components/ForeclosureMonitoringTab/ForeclosureMonitoringTab'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { PropertyMonitoringViewType } from '../components/PropertyMonitoringViewType/PropertyMonitoringViewType'
import { TabLabel } from '../components/TabLabel/TabLabel'
import { monitoringTabSlug, TabItem, tabsProps } from '../utils/tabsHelpers'
import { useInitialFetchWatchdog } from '../utils/useFetchWatchdog'
import { useTabKeyState } from '../utils/useTabKeyState'

const labelClassName = 'text-base text-center block w-28'

export const ForeclosureMonitoring: FunctionComponent = () => {
  useInitialFetchWatchdog()
  const [activeTabKey, setActiveTabKey] = useTabKeyState<PROPERTY_TYPES>(
    PROPERTY_TYPES.BUILDING,
    monitoringTabSlug
  )

  const tabItems = useMemo<TabItem<PROPERTY_TYPES>[]>(
    () => [
      {
        key: PROPERTY_TYPES.BUILDING,
        label: <TabLabel title="Budovy" className={labelClassName} />,
        children: (
          <ForeclosureMonitoringTab propertyType={PROPERTY_TYPES.BUILDING} />
        ),
      },
      {
        key: PROPERTY_TYPES.AREA,
        label: <TabLabel title="Pozemky" className={labelClassName} />,
        children: (
          <ForeclosureMonitoringTab propertyType={PROPERTY_TYPES.AREA} />
        ),
      },
      {
        key: PROPERTY_TYPES.UNIT,
        label: <TabLabel title="Jednotky" className={labelClassName} />,
        children: (
          <ForeclosureMonitoringTab propertyType={PROPERTY_TYPES.UNIT} />
        ),
      },
    ],
    []
  )

  return (
    <>
      <PageLayout title="Monitoring exekucí - výpis nemovitostí" isContainer>
        <Tabs
          {...tabsProps}
          items={tabItems}
          activeKey={activeTabKey}
          onTabClick={setActiveTabKey}
          tabBarExtraContent={<PropertyMonitoringViewType />}
        />
      </PageLayout>
      <PropertyDetailDrawer />
    </>
  )
}

export default ForeclosureMonitoring
